import { useEffect, useMemo } from 'react'
import { useDispatch } from 'react-redux'
import { useOutletContext } from 'react-router'

import { PageLevelTableWrapper, TableColumns, useTableReducer } from '@base'
import { Table as TableV2 } from '@baseV2'
import { DRAWER_TYPES, logisticsStatus, strings } from '@constants'
import { getlogisticsPrices } from '@data'
import { toggleDrawer } from '@data/state/action/root'
import { displayAmount } from '@utils'
import { showLoader } from '@data/state/action'

const LogisticsPrices = () => {
	const [state, dispatch, actions] = useTableReducer(logisticsStatus)
	const globalDispatch = useDispatch()
	const [forceUpdate, update] = useOutletContext()

	useEffect(() => {
		if (state.loading) return

		dispatch(actions.fetchTableDataProgress())
		globalDispatch(showLoader(true))
		getlogisticsPrices(state.query.page)
			.then((response) => {
				// filter and sort logic
				let filteredData = response.data
				filteredData.sort((a, b) => {
					const getPriority = (_address) => {
						if (_address?.city) return 1
						if (_address?.state) return 2
						if (_address?.pincode) return 3
						return 4
					}
					return getPriority(a?.origin) - getPriority(b?.origin)
				})

				let filteredCount = filteredData.length
				dispatch(actions.fetchTableDataSuccess(filteredData, filteredCount))
			})
			.catch((err) => dispatch(actions.fetchTableDataFailure(err)))
			.finally(() => {
				globalDispatch(showLoader(false))
			})
	}, [state.query, forceUpdate])

	const columns = useMemo(
		() =>
			[
				TableColumns.addressColumn({
					align: 'left',
					key: 'origin',
					label: strings('from'),
					mobile: true,
				}),
				TableColumns.addressColumn({
					align: 'left',
					key: 'destination',
					label: strings('to'),
					mobile: true,
				}),

				{
					key: (item) => {
						return `${displayAmount(item.rate_range_from)} - ${displayAmount(item.rate_range_to)}`
					},
					label: strings('price_range'),
					align: 'left',
					mobile: true,
				},
				// v2 Table enables sorting by default; keep all columns non-sortable.
			].map((col) => ({ ...col, sortable: false })),
		[]
	)
	const changePageHandler = (next = true) => {
		dispatch(actions.changePage(next))
	}

	const rowClickHandler = (data) => {
		globalDispatch(toggleDrawer(true, DRAWER_TYPES.LOGISTICS_ADD_PRICE, { selectedRow: data, editable: true, update }))
	}

	return (
		<PageLevelTableWrapper>
			<TableV2
				data={state.data}
				columns={columns}
				loading={state.loading}
				rowsToDisplay={state.total_count}
				totalItemCount={state.total_count}
				page={state.query.page}
				onPageChange={changePageHandler}
				onRowClick={rowClickHandler}
				emptyState={{ text: 'No logistics prices found' }}
			/>
		</PageLevelTableWrapper>
	)
}

export default LogisticsPrices
